import { AnswerType } from '../../shared/enums/answer.enum';
import { Answer } from './answer.model';

export type GapMatchQuestionAnswer = (string | number)[];

// Without this dynamic parameter AOT compiling will fail.
// @see https://angular.io/guide/angular-compiler-options#strictmetadataemit
// @dynamic
export class GapMatchAnswer extends Answer {
  public answer: GapMatchQuestionAnswer | undefined;

  constructor(id: string, type: AnswerType, answer?: GapMatchQuestionAnswer) {
    super();
    this.id = id;
    this.type = type;
    this.answer = answer;
  }

  public static fromDto(dto: any): GapMatchAnswer {
    return new GapMatchAnswer(
      dto.id,
      dto.type,
      dto.answer ?? dto.gapMatchFieldAnswers,
    );
  }
}
